import { render, staticRenderFns } from "./EditorToolbar.vue?vue&type=template&id=07ce45b8"
import script from "./EditorToolbar.vue?vue&type=script&lang=js"
export * from "./EditorToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports